export const contentData = {
  spanish:{
    menu:[
      {id:0, label:'Mi Perfil', path:'/profile', icon:'person'},
      {id:1, label:'Cerrar Sesión', path:'/signin', icon:'exit_to_app'},
    ]
  }
}
